import ui from "./ui.module.css";

// The Teacher App's white header with the logo. A live lesson has no
// navigation: a learner only ever sees the task in front of them. Work done
// outside a lesson (homework, My Learning) offers one way back, `onBack`.
// `progress` shows the lesson player's progress bar while an activity is open.
const Frame = ({ progress, centered, narrow, onBack, backLabel = "Back", children }) => (
  <>
    <header className={ui.header}>
      <div className={ui.headerInner}>
        {onBack && (
          <button type="button" className={`${ui.button} ${ui.secondary}`} onClick={onBack}>
            {backLabel}
          </button>
        )}
        <img
          src={`${process.env.PUBLIC_URL}/thutotime-logo.svg`}
          alt="Thuto Time"
          className={ui.logo}
        />
        {progress && (
          <progress
            className={ui.progress}
            value={progress.current}
            max={progress.total}
            aria-label={`Part ${progress.current} of ${progress.total}`}
          />
        )}
      </div>
    </header>
    <main
      className={[ui.page, centered && ui.centered, narrow && ui.narrow]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </main>
  </>
);

export default Frame;
